import { take, timer } from 'rxjs';
import { TokenAuthentication } from '../token/service';

/**
 * Redirect after a short delay to give a little bit of time to save async logs
 */
const redirect = async (redirectUri: string) => {
  await timer(1000).pipe(take(1)).toPromise();
  window.location.href = `${window.location.origin}${redirectUri}`;
};

/**
 * Logs out the user from the current API and Okta session and redirects to a
 * provided page. If no redirect path is provided, the user is taken to
 * RoutePaths.login
 * @param redirectUri The local path to redirect to
 */
export const logout = async (redirectUri: string) => {
  await TokenAuthentication.clear();
  localStorage.removeItem('accountMeta');

  /**
   * A redirect or window.location.reload() is recommended to ensure proper
   * re-initialization of app and okta auth sdk. Refer:
   * https://www.npmjs.com/package/@okta/okta-auth-js#closesession
   */
  await redirect(redirectUri);
};
